// src/utils/accountEditValidation.js

// ユーザー名のバリデーション
const validateUsername = (username) => {
  const errors = [];
  
  if (!username || username.trim() === '') {
    errors.push('ユーザー名は必須です');
  }
  
  return errors;
};

// アカウント名（メールアドレス）のバリデーション
const validateAccountname = (accountname) => {
  const errors = [];
  
  if (!accountname || accountname.trim() === '') {
    errors.push('アカウント名（メールアドレス）は必須です');
  }
  
  return errors;
};

// フォーム全体のバリデーション
export const validateAccountEditForm = (formData, isEmailEditable = true) => {
  const errors = {
    username: [],
    accountname: [],
    hasErrors: false
  };
  
  // ユーザー名バリデーション
  errors.username = validateUsername(formData.username);
  
  // アカウント名バリデーション（編集可能な場合のみ）
  if (isEmailEditable) {
    errors.accountname = validateAccountname(formData.accountname);
  } else {
    errors.accountname = [];
  }
  
  // エラーがあるかどうかを判定
  errors.hasErrors = errors.username.length > 0 || errors.accountname.length > 0;
  
  return errors;
};

// バリデーション結果から最初のエラーメッセージを取得
export const getFirstErrorMessage = (validationResult) => {
  if (validationResult.username.length > 0) {
    return validationResult.username[0];
  }
  if (validationResult.accountname.length > 0) {
    return validationResult.accountname[0];
  }
  return null;
};